/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { Typography } from "@mui/material";
import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";

const SimplicityDialogContent = ({ children, description, title, handleClose, height, compact }) => {
    const dialogContentContainerStyle = {
        display: "flex",
        flexDirection: "column",
        padding: "2em",
        height: height || "600px",
        overflow: "hidden",
    };
    return (
        <div style={dialogContentContainerStyle}>
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                }}
            >
                <div>
                    <Typography component='div' variant='h3'>
                        {title}
                    </Typography>
                    <Typography variant='subtitle1' color='text.secondary' component='div' mb={compact ? 0 : 4}>
                        <span dangerouslySetInnerHTML={{ __html: description }}></span>
                    </Typography>
                </div>
                <div>
                    <Button
                        variant='text'
                        color='neutral'
                        size='large'
                        onClick={handleClose}
                        startIcon={<CloseIcon />}
                    />
                </div>
            </div>
            <div style={{ height: "100%" }}>{children}</div>
        </div>
    );
};

export default SimplicityDialogContent;
